import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";

import { useMediaQuery } from "react-responsive";

import { Button, Col, Image, Row, Carousel } from "react-bootstrap";
import YouTube from "react-youtube";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";

import {
  FaApple,
  FaAndroid,
  FaInstagram,
  FaLinkedin,
  FaWeight,
  FaShieldAlt,
  FaPills,
} from "react-icons/fa";

import Colors from "../../constants/Colors";

const pageStyle = {
  minHeight: "100vh",
  backgroundColor: "white",
  overflow: "hidden",
};

const containerShadow = {
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
  borderRadius: "12px",
  zIndex: 1,
};

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
};

const flipperContainer = {
  width: "100%",
  height: "100%",
  position: "relative",
  transformStyle: "preserve-3d",
  cursor: "pointer",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
  borderRadius: "12px",
  zIndex: 1,
};

const flipper = {
  position: "absolute",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "1rem",
  backfaceVisibility: "hidden",
  backgroundColor: Colors.backgroundTertiary,
  borderRadius: 8,
};

const getTexts = (lang) => {
  if (lang === "pl") {
    return {
      language: "English",
      slogan: "Poznaj swojego prywatnego asystenta profilaktyki!",
      advertMain:
        "Twoje zdrowie zależy od danych, których jeszcze nie zbierasz!",
      advertAdditional: "Zacznij z DIAGME i bądź gotowy na przyszłość.",
      labMain: "Kiedy, jak, gdzie i o co chodzi z tymi badaniami?",
      labAdditional:
        "Jak tylko lepiej się poznamy doradzę Ci, jakie badania kontrolne zrobić i poprowadzę Cię przez nie za rękę!",
      wearablesMain: "Skąd zdobyć te wszystkie dane?",
      wearablesAdditional:
        "Garmin, Apple, Samsung... Te zegarki mierzą więcej niż Ci się wydaje! Podłącz je do aplikacji i dowiedz się więcej o sobie.",
      dataMain: "Chcesz lepiej zadbać o zdrowie, ale zawsze brakuje Ci czasu?",
      dataAdditional:
        "Będę stale analizował Twoje wyniki, śledził postępy i doradzę, co zrobić, żeby czuć się lepiej!",
      suppMain: "Wiesz, że czegoś Ci brakuje, ale czego?",
      suppAdditional:
        "Tak, wiem, suplementy są wszędzie, a ja znam się na tym! Z chęcią pomogę Ci wybrać te, których potrzebujesz, a do tego nie wydać fortuny!",
      reportMain:
        "Połowa spotkania z lekarzem to omawianie wyników z ostatnich lat?",
      reportAdditional:
        "Wykorzystajcie mój raport i skupcie się na diagnozie, a nie wertowaniu stosu makulatury!",
      medicalMain:
        "Twoje zdrowie zależy od danych, których jeszcze nie zbierasz!",
      medicalAdditioanl: "Zacznij z DIAGME i bądź gotowy na przyszłość.",
      medicalMeasurements:
        "Wszystkie pomiary należy wykonywać ostrożnie, zgodnie z instrukcjami dostarczonymi przez producenta urządzenia.",
      medicalSupplementation:
        "W pierwszej kolejności stawiaj na pełnowartościową żywność. Suplementy stosuj w razie potrzeby i zawsze sprawdzaj dołączoną ulotkę.",
      medicalData:
        "Twoje dane są bezpiecznie przechowywane i przetwarzane zgodnie z przepisami o ochronie danych osobowych obowiązującymi w UE.",
      contact: "Kontakt",
      privacy: "Polityka prywatności",
      cookieText:
        "Używamy plików cookie, aby poprawić Twoje doświadczenia. Przeczytaj więcej w naszej Polityce Prywatności.",
      cookieAccept: "Rozumiem i akceptuje",
      cookieDecline: "Pomiń",
    };
  } else {
    return {
      language: "Polski",
      slogan: "Meet your personal medical assistant!",
      advertMain: "Your health depends on data you're not collecting yet!",
      advertAdditional: "Start with DIAGME and be ready for the future.",
      labMain: "When, how, where, and what are these examinations about?",
      labAdditional:
        "As soon as we get to know each other better, I will advise you on which check-ups to do and guide you by hand!",
      wearablesMain: "Where to gather all this data?",
      wearablesAdditional:
        "Garmin, Apple, Samsung... These watches measure more than you think! Connect them to the app and learn more about yourself.",
      dataMain:
        "Do you want to take better care of your health but lack the time?",
      dataAdditional:
        "I’ll constantly analyze your results, track your progress, and advise what to do to feel better!",
      suppMain: "You know you're missing something, but what?",
      suppAdditional:
        "Yes, I know – supplements are everywhere, and I can help! I'll be happy to recommend the ones you need without spending a fortune.",
      reportMain:
        "Half of your doctor visit is spent discussing results from the last few years?",
      reportAdditional:
        "Use my report so you can focus on the diagnosis, not on digging through piles of paper!",
      medicalMain: "Your health depends on data you're not collecting yet!",
      medicalAdditioanl: "Start with DIAGME and be ready for the future.",
      medicalMeasurements:
        "All measurements shall be done cautiously, according to the instructions provided by the manufacturer of the device.",
      medicalSupplementation:
        "Prioritize whole foods. Consider supplements if needed and always check attached product information leaflet.",
      medicalData:
        "Your data is stored securely and processed in line with EU data protection laws.",
      contact: "Contact",
      privacy: "Privacy policy",
      cookieText:
        "We use cookies to improve your experience. Read more in our Privacy Policy.",
      cookieAccept: "I understant and consent",
      cookieDecline: "Skip",
    };
  }
};

const getDiagramImageName = (lang, isMobile) => {
  if (lang === "pl" && isMobile) return "/diagrams/diagram-pl-mobile.jpg";
  if (lang === "pl" && !isMobile) return "/diagrams/diagram-pl.jpg";
  if (lang === "en" && isMobile) return "/diagrams/diagram-en-mobile.jpg";
  if (lang === "en" && !isMobile) return "/diagrams/diagram-en.jpg";
};

const getScreenShotsByLang = (lang) => {
  if (lang === "pl") {
    return [
      "/screenshots/app-1-pl.jpg",
      "/screenshots/app-2-pl.jpg",
      "/screenshots/app-3-pl.jpg",
      "/screenshots/app-4-pl.jpg",
    ];
  } else {
    return [
      "/screenshots/app-1-en.jpg",
      "/screenshots/app-2-en.jpg",
      "/screenshots/app-3-en.jpg",
      "/screenshots/app-4-en.jpg",
    ];
  }
};

const getStartLang = (storedLang, urlLang) => {
  const browser = window.navigator.userLanguage || window.navigator.language;
  if (urlLang) {
    return urlLang;
  }
  if (storedLang) {
    return storedLang;
  }
  return browser.includes("pl") ? "pl" : "en";
};

function Landing() {
  const storedLang = localStorage.getItem("lang");
  const [searchParams] = useSearchParams();

  const [lang, setLang] = useState(
    getStartLang(storedLang, searchParams.get("lang"))
  );
  const [flippedIndex, setFlippedIndex] = useState(null);

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const onLangToggle = () => {
    const newLang = lang === "pl" ? "en" : "pl";
    localStorage.setItem("lang", newLang);
    setLang(newLang);
  };

  const texts = getTexts(lang);
  const diagramName = getDiagramImageName(lang, isMobile);
  const screenshots = getScreenShotsByLang(lang);

  useEffect(() => {
    const consent = getCookieConsentValue();
    if (consent === "true") {
      console.log("Landing useEffect cookies accpeted");
      loadAnalytics();
    }
  }, []);

  const loadAnalytics = () => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-6TJS7YJJ1R";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-6TJS7YJJ1R");
    };
  };

  const handleMobileFlip = (index) => {
    if (flippedIndex === index) {
      setFlippedIndex(null);
    } else {
      setFlippedIndex(index);
    }
  };

  const panels = [
    {
      icon: <FaWeight size={70} color={Colors.secondary} />,
      text: texts.medicalMeasurements,
    },
    {
      icon: <FaPills size={70} color={Colors.secondary} />,
      text: texts.medicalSupplementation,
    },
    {
      icon: <FaShieldAlt size={70} color={Colors.secondary} />,
      text: texts.medicalData,
    },
  ];

  const carouselItems = screenshots.map((src) => (
    <Carousel.Item key={src}>
      <Image
        className="mt-4 mb-4"
        src={process.env.PUBLIC_URL + src}
        fluid
        style={{
          ...containerShadow,
          objectFit: "cover",
          maxHeight: isMobile ? "400px" : "600px",
        }}
      />
    </Carousel.Item>
  ));

  // A reusable fade-in image+text block with motion animations
  const FadeInSection = ({ imageLeft = true, imgSrc, title, description }) => {
    return (
      <Row
        className="ms-0 me-0 p-5 align-items-center"
        style={{ backgroundColor: Colors.backgroundTertiary }}
      >
        {/* If imageLeft, place image first on md+ devices */}
        {imageLeft && (
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center mb-4 mb-md-0"
          >
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={fadeInUp}
              viewport={{ once: true }}
              style={containerShadow}
            >
              <Image
                src={process.env.PUBLIC_URL + imgSrc}
                fluid
                style={{ borderRadius: 8 }}
              />
            </motion.div>
          </Col>
        )}
        <Col xs={12} md={6}>
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={fadeInUp}
            viewport={{ once: true }}
          >
            <h2 style={{ color: Colors.secondary, fontWeight: 700 }}>
              {title}
            </h2>
            <p style={{ fontSize: "1.2rem", color: Colors.secondary }}>
              {description}
            </p>
          </motion.div>
        </Col>
        {/* If imageRight, place image last on md+ devices */}
        {!imageLeft && (
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center mt-4 mt-md-0"
          >
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={fadeInUp}
              viewport={{ once: true }}
              style={containerShadow}
            >
              <Image
                src={process.env.PUBLIC_URL + imgSrc}
                fluid
                style={{ borderRadius: 8 }}
              />
            </motion.div>
          </Col>
        )}
      </Row>
    );
  };

  return (
    <div style={pageStyle}>
      {/* Top Language Toggle */}
      <Row className="ms-0 me-0 p-3 justify-content-end" style={{ zIndex: 2 }}>
        <Col xs="auto">
          <Link
            onClick={() => onLangToggle()}
            style={{ textDecoration: "none", cursor: "pointer" }}
          >
            <span
              style={{
                color: Colors.quaternary,
                fontWeight: 700,
                fontSize: isMobile ? 14 : 16,
              }}
            >
              {texts.language}
            </span>
          </Link>
        </Col>
      </Row>

      {/* Hero / Slogan Section */}
      <Row
        className="ms-0 me-0 p-3 d-flex align-items-center justify-content-center"
        style={{ zIndex: 2 }}
      >
        <Col
          xs={12}
          md={4}
          className="d-flex justify-content-center mb-3 mb-md-0"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.7 }}
            style={{ ...containerShadow, padding: 10, borderRadius: 10 }}
          >
            <Image
              src={process.env.PUBLIC_URL + "/logo192.png"}
              width={isMobile ? 150 : 300}
              fluid
            />
          </motion.div>
        </Col>
        <Col xs={12} md={6}>
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7 }}
          >
            <h1
              className="text-center text-md-start"
              style={{
                color: Colors.secondary,
                fontSize: isMobile ? 32 : 46,
                fontWeight: 700,
                marginBottom: 20,
              }}
            >
              {texts.slogan}
            </h1>

            <div className="text-center text-md-start">
              <Link
                to="https://apps.apple.com/us/app/diagme/id6469189916?platform=iphone"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="primary"
                  size="lg"
                  className="align-items-center me-3 mb-2"
                  style={{ borderRadius: "30px" }}
                >
                  <FaApple
                    style={{ marginRight: "0.5rem", marginBottom: "0.3rem" }}
                  />
                  iOS
                </Button>
              </Link>
              <Link
                to="https://play.google.com/store/apps/details?id=online.diagme"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="primary"
                  size="lg"
                  className="mb-2"
                  style={{ borderRadius: "30px" }}
                >
                  <FaAndroid
                    style={{ marginRight: "0.5rem", marginBottom: "0.3rem" }}
                  />
                  Android
                </Button>
              </Link>
            </div>
          </motion.div>
        </Col>
      </Row>

      {/* Modern Ad / Pitch Header */}
      <Row className="mt-5" />
      <Row
        className="mt-5 ms-0 me-0 text-center p-5"
        style={{
          backgroundColor: Colors.backgroundSecondary,
          color: Colors.backgroundPrimary,
        }}
      >
        <Row className="mt-4">
          <h3 style={{ fontWeight: 700, fontSize: isMobile ? 24 : 40 }}>
            {texts.advertMain}
          </h3>
          <p style={{ fontSize: isMobile ? "1rem" : "1.5rem" }}>
            {texts.advertAdditional}
          </p>
        </Row>
      </Row>

      {/* Diagram Section */}
      <Row className="ms-0 me-0 text-center p-5" style={{ zIndex: 2 }} />
      <Row
        className="ms-0 me-0 p-3 justify-content-center"
        style={{ zIndex: 2 }}
      >
        <Col xs={12} md={10}>
          <motion.div
            initial={{ x: -30, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            style={{
              ...containerShadow,
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <Image
              src={process.env.PUBLIC_URL + diagramName}
              fluid
              alt="App Diagram"
            />
          </motion.div>
        </Col>
      </Row>

      {/* YouTube Section */}
      <Row className="ms-0 me-0 text-center p-5" style={{ zIndex: 2 }} />
      <Row
        className="ms-0 me-0 mt-3 p-3 text-center justify-content-center"
        style={{ zIndex: 2 }}
      >
        <Col
          xs={12}
          md={6}
          style={{ ...containerShadow, paddingTop: 10, borderRadius: 10 }}
        >
          <YouTube videoId="U4REZkjndUg" opts={{ width: "100%" }} />
        </Col>
      </Row>

      {/* Features / In-depth explanations - refactored to FadeInSection */}
      <Row className="ms-0 me-0 text-center p-5" style={{ zIndex: 2 }} />
      <FadeInSection
        imageLeft
        imgSrc="/images/examinations.jpg"
        title={texts.labMain}
        description={texts.labAdditional}
      />
      <FadeInSection
        imageLeft={isMobile}
        imgSrc="/images/wearables.jpg"
        title={texts.wearablesMain}
        description={texts.wearablesAdditional}
      />
      <FadeInSection
        imageLeft
        imgSrc="/images/data.jpg"
        title={texts.dataMain}
        description={texts.dataAdditional}
      />
      <FadeInSection
        imageLeft={isMobile}
        imgSrc="/images/supplements.jpg"
        title={texts.suppMain}
        description={texts.suppAdditional}
      />
      <FadeInSection
        imageLeft
        imgSrc="/images/visit.jpg"
        title={texts.reportMain}
        description={texts.reportAdditional}
      />

      {/* Modern Ad / Pitch Header */}
      <Row className="ms-0 me-0 text-center p-5" style={{ zIndex: 2 }} />
      <Row
        className="ms-0 me-0 text-center p-5"
        style={{
          backgroundColor: Colors.backgroundSecondary,
          color: Colors.backgroundPrimary,
          zIndex: 2,
        }}
      >
        <Row className="mt-4">
          <h3 style={{ fontWeight: 700, fontSize: isMobile ? 24 : 40 }}>
            {texts.advertMain}
          </h3>
          <p style={{ fontSize: isMobile ? "1rem" : "1.5rem" }}>
            {texts.advertAdditional}
          </p>
        </Row>

        {/* Flip panels row */}
        <Row className="mt-5 d-flex justify-content-center">
          {panels.map((panel, idx) => {
            // If on mobile, we flip if index == flippedIndex.
            // If on desktop, we rely on whileHover for the flip.
            const rotateY = isMobile && flippedIndex === idx ? 180 : 0;
            return (
              <Col
                key={idx}
                xs={12}
                md={3}
                className="d-flex justify-content-center mb-4"
              >
                {/* Perspective container for 3D effect */}
                <motion.div
                  style={{
                    width: 200,
                    height: 200,
                    perspective: 500,
                  }}
                >
                  <motion.div
                    style={flipperContainer}
                    whileHover={!isMobile ? { rotateY: 180 } : {}}
                    animate={{ rotateY }}
                    transition={{ duration: 0.6 }}
                    onClick={() => {
                      if (isMobile) handleMobileFlip(idx);
                    }}
                  >
                    {/* Front side */}
                    <div style={flipper}>{panel.icon}</div>
                    {/* Back side */}
                    <div style={{ ...flipper, transform: "rotateY(180deg)" }}>
                      <p
                        style={{
                          marginTop: 10,
                          fontSize: isMobile ? 12 : 14,
                          color: Colors.secondary,
                          fontWeight: "bold",
                        }}
                      >
                        {panel.text}
                      </p>
                    </div>
                  </motion.div>
                </motion.div>
              </Col>
            );
          })}
        </Row>
      </Row>

      {/* App Screens Carousel */}
      <Row
        className="ms-0 me-0 mt-5 p-3 text-center justify-content-center"
        style={{ zIndex: 2 }}
      >
        <Col xs={12} md={8}>
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Carousel variant="dark" interval={3000}>
              {carouselItems}
            </Carousel>
          </motion.div>
        </Col>
      </Row>

      {/* Footer */}
      <Row
        className="ms-0 me-0 mt-5 pt-4 pb-4 text-center"
        style={{ backgroundColor: Colors.primary, zIndex: 2 }}
      >
        <Col xs={12} md={6} className="mb-3 mb-md-0">
          <Link to="contact" style={{ textDecoration: "none" }}>
            <p
              style={{
                color: Colors.backgroundPrimary,
                fontSize: isMobile ? 14 : 16,
              }}
            >
              {texts.contact}
            </p>
          </Link>
          <Link to={"privacy-" + lang} style={{ textDecoration: "none" }}>
            <p
              style={{
                color: Colors.backgroundPrimary,
                fontSize: isMobile ? 14 : 16,
              }}
            >
              {texts.privacy}
            </p>
          </Link>
        </Col>
        <Col xs={12} md={6}>
          <Row className="justify-content-center">
            <Col xs="auto">
              <Link
                to="https://www.instagram.com/barwalll/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram
                  style={{ height: 45, width: 45, cursor: "pointer" }}
                  color={Colors.backgroundPrimary}
                />
              </Link>
            </Col>
            <Col xs="auto">
              <Link
                to="https://www.linkedin.com/in/bartosz-nawrot-aab890127/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin
                  style={{ height: 45, width: 45, cursor: "pointer" }}
                  color={Colors.backgroundPrimary}
                />
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      <CookieConsent
        location="bottom"
        buttonText={texts.cookieAccept}
        declineButtonText={texts.cookieDecline}
        enableDeclineButton
        style={{
          background: Colors.backgroundTertiary,
          color: Colors.secondary,
          fontWeight: "bold",
        }}
        buttonStyle={{
          backgroundColor: Colors.primary,
          color: Colors.backgroundPrimary,
          fontWeight: "bold",
        }}
        declineButtonStyle={{
          backgroundColor: Colors.backgroundQuaternary,
          color: "#4e503b",
        }}
        acceptOnScroll
        onAccept={() => {
          console.log("Landing CookieConsent cookies accepted");
          loadAnalytics();
        }}
        overlay
      >
        {texts.cookieText}
      </CookieConsent>
    </div>
  );
}

export default Landing;
